import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { QueryParamsModel } from "../../_base/crud";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class DebtsService {
  private API_DEBTS_URL = environment.API_URL + "api/ResellerStatement/OrdersTransaction/findOrdersDebts";
  private API_DEBTS_EXCEL_URL = environment.API_URL + "api/ResellerStatement/OrdersTransaction/download";
  private API_ACCOUNT_MOVEMENTS_URL = environment.API_URL + "api/ResellerStatement/OrdersTransaction/findTransacionMovements";
  private API_ACCOUNT_MOVEMENTS_EXCEL_URL = environment.API_URL + "api/ResellerStatement/OrdersTransaction/downloadMovements";

  constructor(private http: HttpClient) {}

  findDebts(query: QueryParamsModel): Observable<any> {
    return this.http.post(this.API_DEBTS_URL, query);
  }

  downloadDebts(query: QueryParamsModel): Observable<any> {
    return this.exportExcel(query, this.API_DEBTS_EXCEL_URL, "post");
    // return this.http.post(this.API_DEBTS_EXCEL_URL, query);
  }

  downloadMovements(query: QueryParamsModel): Observable<any> {
    return this.exportExcel(query, this.API_ACCOUNT_MOVEMENTS_EXCEL_URL, "post");
    // return this.http.post(this.API_DEBTS_EXCEL_URL, query);
  }

  getPaymentEntities() {
      return this.http.get(environment.API_URL + "api/ResellerStatement/PaymentEntities");
  }

  exportExcel(data, url, method) {
    if (method === "get") {
      return this.http.get(url, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    } else {
      return this.http.post(url, data, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    }
  }

  findAccountMovements(query: QueryParamsModel): Observable<any> {
    return this.http.post(this.API_ACCOUNT_MOVEMENTS_URL, query);
  }
}
